import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/cafe.svg'


const _hoisted_1 = {
  class: "modal modal-lg fade",
  id: "modal-version",
  tabindex: "-1"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = { class: "modal-version-body" }
const _hoisted_6 = { class: "modal-version-fields" }
const _hoisted_7 = {
  class: "btn btn-tag btn-sm btn-grayscale-dark btn-version",
  type: "button",
  "data-bs-target": "#modal-version",
  "data-bs-toggle": "modal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _cache[12] || (_cache[12] = _createElementVNode("h2", null, "Versão", -1)),
                _cache[13] || (_cache[13] = _createElementVNode("h4", { class: "mt-4" }, "FRONTEND", -1)),
                _createElementVNode("p", null, [
                  _cache[0] || (_cache[0] = _createElementVNode("strong", null, "tag", -1)),
                  _createTextVNode(": \"" + _toDisplayString(_ctx.model.front.tag) + "\",", 1)
                ]),
                _createElementVNode("p", null, [
                  _cache[1] || (_cache[1] = _createElementVNode("strong", null, "buildDate", -1)),
                  _createTextVNode(": \"" + _toDisplayString(_ctx.model.front.buildDate) + "\"", 1)
                ]),
                _createElementVNode("p", null, [
                  _cache[2] || (_cache[2] = _createElementVNode("strong", null, "branch", -1)),
                  _createTextVNode(": \"" + _toDisplayString(_ctx.model.front.branch) + "\"", 1)
                ]),
                _createElementVNode("p", null, [
                  _cache[3] || (_cache[3] = _createElementVNode("strong", null, "commit", -1)),
                  _createTextVNode(": \"" + _toDisplayString(_ctx.model.front.commit) + "\"", 1)
                ]),
                _createElementVNode("p", null, [
                  _cache[4] || (_cache[4] = _createElementVNode("strong", null, "buildNumber", -1)),
                  _createTextVNode(": \"" + _toDisplayString(_ctx.model.front.buildNumber) + "\"", 1)
                ]),
                _createElementVNode("p", null, [
                  _cache[5] || (_cache[5] = _createElementVNode("strong", null, "repo", -1)),
                  _createTextVNode(": \"" + _toDisplayString(_ctx.model.front.repo) + "\"", 1)
                ]),
                _cache[14] || (_cache[14] = _createElementVNode("h4", null, "BACKEND:", -1)),
                _createElementVNode("p", null, [
                  _cache[6] || (_cache[6] = _createElementVNode("strong", null, "tag", -1)),
                  _createTextVNode(": \"" + _toDisplayString(_ctx.model.back.tag) + "\",", 1)
                ]),
                _createElementVNode("p", null, [
                  _cache[7] || (_cache[7] = _createElementVNode("strong", null, "buildDate", -1)),
                  _createTextVNode(": \"" + _toDisplayString(_ctx.model.back.buildDate) + "\"", 1)
                ]),
                _createElementVNode("p", null, [
                  _cache[8] || (_cache[8] = _createElementVNode("strong", null, "branch", -1)),
                  _createTextVNode(": \"" + _toDisplayString(_ctx.model.back.branch) + "\"", 1)
                ]),
                _createElementVNode("p", null, [
                  _cache[9] || (_cache[9] = _createElementVNode("strong", null, "commit", -1)),
                  _createTextVNode(": \"" + _toDisplayString(_ctx.model.back.commit) + "\"", 1)
                ]),
                _createElementVNode("p", null, [
                  _cache[10] || (_cache[10] = _createElementVNode("strong", null, "buildNumber", -1)),
                  _createTextVNode(": \"" + _toDisplayString(_ctx.model.back.buildNumber) + "\"", 1)
                ]),
                _createElementVNode("p", null, [
                  _cache[11] || (_cache[11] = _createElementVNode("strong", null, "repo", -1)),
                  _createTextVNode(": \"" + _toDisplayString(_ctx.model.back.repo) + "\"", 1)
                ])
              ]),
              _cache[15] || (_cache[15] = _createElementVNode("div", { class: "modal-version-image" }, [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "Imagem ilustrativa de uma mão segunrando café"
                })
              ], -1))
            ])
          ]),
          _cache[16] || (_cache[16] = _createElementVNode("div", { class: "modal-footer" }, [
            _createElementVNode("button", {
              class: "btn btn-primary",
              type: "button",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, "Fechar")
          ], -1))
        ])
      ])
    ]),
    _createElementVNode("button", _hoisted_7, _toDisplayString(`V.${_ctx.model.front.tag}`), 1)
  ], 64))
}